import { t } from "@/i18n-js/instance";
import { planFeatures } from "@/react/helpers/plansHelpers";

import { FeatureFlags } from "../FeatureFlags";
import { FeatureRow } from "../FeatureRow";
import { usePlans } from "../PlansContext";
import { PlanFeatureFlag } from "./../PlanFeatureFlag";
import { SectionWrapper } from "./SectionWrapper";
import { StorageRow } from "./StorageRow";

export const Community = () => {
  const { compareTablePlanFeatures } = usePlans();

  if (!compareTablePlanFeatures) return null;

  return (
    <SectionWrapper sectionName={t("pricing_plans.section.community")}>
      <FeatureFlags
        featureFlagKeys={[
          planFeatures.max_member_count,
          planFeatures.max_admin_count,
          planFeatures.max_moderator_count,
        ]}
      />
      <FeatureRow
        title={t("pricing_plans.feature.max_space_count")}
        professional={`${compareTablePlanFeatures.professional?.max_space_count}`}
        enterprise={`${compareTablePlanFeatures.enterprise?.max_space_count}`}
        business={`${compareTablePlanFeatures.business?.max_space_count}`}
        plus={t("pricing_plans.feature.flexible")}
      />
      <PlanFeatureFlag
        title={t("pricing_plans.feature.transaction_fees")}
        feature={planFeatures.payments_fee_percentage}
        suffix="%"
      />
      <StorageRow />
    </SectionWrapper>
  );
};
